import { useMutation, useQuery } from "@tanstack/react-query";
import { Folder } from "Models/folder";
import FolderService from "Services/folder.service";
import { FoldersKeys } from "Util/queries";

interface IUseActionFolders {
  jobId?: number | string;
}

export const useActionFolders = ({ jobId }: IUseActionFolders) => {
  const getOrderFolders = () => {
    return useQuery({
      queryKey: FoldersKeys.getOrderFolders(Number(jobId || 0)),
      queryFn: async () => {
        const response = await FolderService.getOrderFolders(Number(jobId || 0));

        if (response?.data) return response?.data as Folder[];

        return [] as Folder[];
      },
      enabled: !!jobId,
    });
  };

  const getQuoteFolders = () => {
    return useQuery({
      queryKey: FoldersKeys.getOrderFolders(Number(jobId || 0)),
      queryFn: async () => {
        const response = await FolderService.getQuoteFolders(Number(jobId || 0));

        if (response?.data) return response?.data as Folder[];

        return [] as Folder[];
      },
      enabled: !!jobId,
    });
  };

  const mutateFolders = (
    jobId: number,
    folders: Folder[],
    companyId: number,
    foldersDeleted?: Folder[],
    filesDeleted?: Folder[]
  ) => {
    return useMutation({
      mutationKey: [FoldersKeys.mutateFolders()],
      mutationFn: async (id: number) => {
        const response = await FolderService.createUpdateFolder(
          id ?? jobId,
          folders,
          companyId,
          foldersDeleted,
          filesDeleted
        );

        if (response?.data) return response?.data as Folder[];

        return [] as Folder[];
      },
    });
  };

  return {
    getQuoteFolders,
    getOrderFolders,
    mutateFolders,
  };
};
